export const logout = () => {
    localStorage.removeItem("concUser");
};

export const getLocalToken = () => {
    try {
        return JSON.parse(localStorage.getItem('concUser')).token;
    } catch (err) {
        console.log(err);
        return null;
    }
};